(() => {
	angular
		.module('main')
		.controller(
			'ConfirmForgotPasswordController',
			ConfirmForgotPasswordController
		);

	ConfirmForgotPasswordController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'messageService',
		'stringModifierService'
	];

	function ConfirmForgotPasswordController(
		$scope,
		$rootScope,
		$location,
		$http,
		messageService,
		stringModifierService
	) {
		const request = {
			changePasswordWithToken(
				password,
				password_confirm,
				token,
				changePasswordWithTokenSuccessCallback,
				changePasswordWithTokenErrorCallback
			) {
				$http({
					method: 'POST',
					url: '/public/rest/user/changepassword',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						password,
						password_confirm,
						token
					}
				}).then(
					result => changePasswordWithTokenSuccessCallback(result.data),
					() => changePasswordWithTokenErrorCallback()
				);
			},
			confirmForgot($rootScope, $location, $scope) {
				delete $rootScope.error;

				const restPathUrl = '/public/rest/user/forgotpassword/';
				const confirmPathPart = 'confirm/';
				let url = $location.path();
				const index = url.indexOf(confirmPathPart);
				let token = null;

				if (index && index + confirmPathPart.length < url.length) {
					token = url.substring(confirmPathPart.length + index, url.length);
					url = restPathUrl + token;
				} else {
					url = null;
				}

				if (url) {
					$http.get(url).then(
						result => {
							if (result.data) {
								if (result.data.success) {
									$rootScope.password_token = token;
								} else {
									$rootScope.error = true;
									$rootScope.error_message = result.data.message;
								}

								$scope.userActionResult = result.data;
							}
						},
						() => messageService.showToaster('e_0', 'general')
					);
				}
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			if (!$rootScope.password_token) {
				request.confirmForgot($rootScope, $location, $scope);
				console.log('validationg token');
			}
		});

		$scope.changePassword = (password, passwordConfirm) => {
			delete $scope.userActionResult;
			if ($rootScope.password_token) {
				if (passwordConfirm !== password) {
					return messageService.showToaster('e_0', 'forgotPassword');
				} else if (
					password === undefined ||
					passwordConfirm === undefined ||
					password.trim().length === 0
				) {
					return messageService.showToaster('e_3', 'general', 'password');
				} else if (password.length < 6) {
					return messageService.showToaster('e_1', 'forgotPassword');
				}
				const token = $rootScope.password_token;
				request.changePasswordWithToken(
					password,
					passwordConfirm,
					token,
					changePasswordWithTokenSuccessCallback,
					changePasswordWithTokenErrorCallback
				);
			} else {
				messageService.showToaster('e_2', 'forgotPassword');
				$location.path('/login');
				// toastr["error"]("Forgot password link already used!", 'Error');
			}
		};

		function changePasswordWithTokenSuccessCallback(data) {
			if (data) {
				delete $scope.userActionResult;
				$scope.userActionResult = data;
				if (data.success) {
					toastr.success(data.message);
					$scope.userActionResult = data;
					$location.path('/login');
					delete $rootScope.error;
					delete $rootScope.password_token;
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
				}
			}
		}

		function changePasswordWithTokenErrorCallback() {
			messageService.showToaster('e_0', 'general');
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/confirmForgotPasswordController.js